import { Popover } from '@material-ui/core'
import { PopoverProps } from '@material-ui/core/Popover'
import React from 'react'
import styled from '../../../theme'

const ThemedPopover: React.ComponentType<
  PopoverProps & IThemedPopover
> = styled(Popover)<PopoverProps & IThemedPopover>`
  .popover--paper--with_arrow {
    overflow: visible;
  }
`

export default ThemedPopover

export interface IThemedPopover {
  offsetRight?: number
}
